import { serviceHandler } from './service-executor';

const DATUPLOAD_URL = '/api/data/upload';

export const uploadDataFile = data => {
  const URL = `${DATUPLOAD_URL}`;
  return serviceHandler(URL, 'PUT', data);
};

/* Personnel Document Management */
export const getPersonnelDocuments = (personnelId) => {
  return serviceHandler(`/api/document/personnel/list/${personnelId}`, 'GET');
}
export const uploadDocument = data => {
  const URL = `/api/document/personnel/upload`;
  return serviceHandler(URL, 'PUT', data);
};

export const updateDocument = (data, uuid) => {
  const URL = `/api/document/personnel/update/${uuid}`;
  return serviceHandler(URL, 'PUT', data);
};

export const deleteDocument = (personnelId, uuid) => {
  const URL = `/api/document/delete/${personnelId}/${uuid}`;
  return serviceHandler(URL, 'DELETE');
};

export const downloadDocument = (uuid) => {
  const URL = `/api/document/download/${uuid}`;
  return serviceHandler(URL, 'GET');
};

export const extractPreNoteDocument = (rateCon) => {
  const URL = `/api/v1/ai/extract/otr`;
  return serviceHandler(URL, 'PUT', rateCon);
}